import { prepareQueryInput } from '#domain/performance/kpi/prepare-query-input';
import type { RouterInput } from '../useTrpc';
import type { PrepareInputArgsType } from './types/prepareInputArgs.type';

/**
 * Pre-process the query input to be used in the `useIndicators` methods.
 *
 * @param indicator Specify the name of the indicator required.
 * @param period The period to fetch the data for.
 * @param filters The filters to fetch the data for.
 * @param isWithTax Specify is KPI should include tax or not.
 * @param taxonomy The referential to fetch the data for.
 * @param storePerimeter The store perimeter to fetch the data for.
 * @returns The query object to be used in the `useIndicators` methods.
 */
export function prepareInput({
  indicator,
  period,
  comparisonPeriod,
  detentionPeriod,
  filters,
  isWithTax,
  taxonomy,
  storePerimeter,
  isMyDataIncluded,
  likeForLikeStoreKeys
}: PrepareInputArgsType): RouterInput['performance']['kpi']['getIndicator'] {
  return {
    indicator,
    ...prepareQueryInput({
      period,
      comparisonPeriod,
      detentionPeriod,
      filters,
      isWithTax,
      taxonomy,
      storePerimeter,
      isMyDataIncluded,
      likeForLikeStoreKeys
    })
  };
}
